import { Route } from '@angular/router';
import { LoginPageComponent } from './login.page/login.page.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginQrComponent } from './login-qr/login-qr.component';
import { LoginLegalComponent } from './login-legal/login-legal.component';
import { LoginMobileDownloadComponent } from './login-mobile-download/login-mobile-download.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { RegistrationQrComponent } from './registration-qr/registration-qr.component';
import { loginRoutePaths } from '@ebanking/features/login/login.route-paths';
import { maintenanceCheckGuard } from '@qvs/shared';

const defaultBackgroundImages = [{ class: 'laptop' }];

export const LOGIN_ROUTE: Route = {
  path: '',
  canMatch: [maintenanceCheckGuard],
  component: LoginPageComponent,
  children: [
    { path: '', redirectTo: loginRoutePaths.LOGIN, pathMatch: 'full' },
    {
      path: `${loginRoutePaths.LOGIN}/${loginRoutePaths.SESSION_TIMED_OUT}`,
      redirectTo: loginRoutePaths.LOGIN,
      pathMatch: 'full'
    },
    { path: loginRoutePaths.LOGIN, component: LoginFormComponent, data: { backgroundImages: defaultBackgroundImages } },
    {
      path: loginRoutePaths.REGISTRATION,
      component: RegistrationFormComponent,
      data: { backgroundImages: defaultBackgroundImages }
    },
    {
      path: loginRoutePaths.REGISTRATION_QR,
      component: RegistrationQrComponent,
      data: { backgroundImages: defaultBackgroundImages }
    },
    { path: loginRoutePaths.SCAN, component: LoginQrComponent, data: { backgroundImages: defaultBackgroundImages } },
    {
      path: loginRoutePaths.COOKIE_POLICY,
      component: LoginLegalComponent,
      data: {
        title: 'ebanking.login.COOKIE_POLICY',
        articleText: 'ebanking.login.COOKIE_POLICY_TEXT',
        backgroundImages: [{ class: 'single-background-image__cookie-policy' }]
      }
    },
    {
      path: loginRoutePaths.SECURITY_ADVICE,
      component: LoginLegalComponent,
      data: {
        title: 'ebanking.login.SECURITY_ADVICE',
        articleText: 'ebanking.login.SECURITY_ADVICE_TEXT',
        backgroundImages: [{ class: 'single-background-image__security-advice' }]
      }
    },
    {
      path: loginRoutePaths.ABOUT,
      component: LoginLegalComponent,
      data: {
        title: 'ebanking.login.ABOUT',
        articleText: 'ebanking.login.ABOUT_TEXT',
        backgroundImages: [{ class: 'single-background-image__about-us' }]
      }
    },
    {
      path: loginRoutePaths.MOBILE,
      component: LoginMobileDownloadComponent,
      data: {
        backgroundImages: [{ class: 'single-background-image__download-mobile' }]
      }
    }
  ]
};
